import qs from 'qs';

export const getQueryParamsFromUrl = (
  url: string,
  options: Record<string, string> = { arrayFormat: 'repeat' },
) => {
  const startIndex = url.indexOf('?');

  if (startIndex === -1) {
    return {};
  }
  const queryString = url.substr(startIndex + 1);

  return qs.parse(queryString, options);
};

export const getUrlParsed = (url: string) => {
  const queryParams = getQueryParamsFromUrl(url);
  const urlWithoutQueryString = url.slice(0, url.indexOf('?'));

  return { queryParams, urlWithoutQueryString };
};
